// extracted by mini-css-extract-plugin
export default {"subtitleContainer":"ScoresAlertsDialog_subtitleContainer__qi91C","buttonAdd":"ScoresAlertsDialog_buttonAdd__x4gMj","rulesContainer":"ScoresAlertsDialog_rulesContainer__ggnkk"};